// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"order-descending"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H14M3 12H14M3 19H12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 17L19 20L16 17M19 5L19 18.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const OrderDescendingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'order-descending',
    ref,
    icon: element,
  },
));

OrderDescendingIcon.displayName = 'OrderDescendingIcon';

export default OrderDescendingIcon;
